import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/index.vue'
import ExcelView from '../views/excel.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/excel',
    name: 'excel',
    component: ExcelView
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
